import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 16,
    height: 16,
    // Inherit the parent SidebarItem color so the icon follows the shared
    // grey (inactive) / blue (hover and selected) sidebar states.
    color: 'inherit',
  },
});

/**
 * Scales icon for the Compliance Management sidebar entry.
 */
export const CustomComplianceIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 13H8.5V4H11.4528L9.67506 8H9V9C9 9.85897 9.67034 10.3674 10.1386 10.6015C10.6666 10.8656 11.3261 11 12 11C12.6739 11 13.3334 10.8656 13.8614 10.6015C14.3297 10.3674 15 9.85897 15 9V8H14.3249L12.5472 4H13V3H8.5V2H7.5V3H3V4H3.45284L1.67506 8H1V9C1 9.85897 1.67034 10.3674 2.13857 10.6015C2.66662 10.8656 3.32613 11 4 11C4.67387 11 5.33338 10.8656 5.86143 10.6015C6.32966 10.3674 7 9.85897 7 9V8H6.32493L4.54716 4H7.5V13H5V14H11V13ZM4 5.23111L5.23062 8H2.76938L4 5.23111ZM2 9H6C6 9.55228 5.10457 10 4 10C2.89543 10 2 9.55228 2 9ZM12 5.23111L13.2306 8H10.7694L12 5.23111ZM10 9H14C14 9.55228 13.1046 10 12 10C10.8954 10 10 9.55228 10 9Z"
        fill="currentColor"
      />
    </svg>
  );
};
